import './pricingVersion.scss';
import React from 'react';
import { IPlanInfo } from '@umu/umu-types';
import { VersionItem } from './versionItem';
import { isLang, lang } from '@umu/ukit-lang';
import { Button } from '@umu/umu-design';
import { If } from 'common/src/components';
import { addLangPrefixToUrl } from 'businessCommon/src/@utils/langPrefix';

interface IPricingVersionProps {
    isRegisterUser: boolean;
    planInfo: IPlanInfo;
    siteHost: string;
    platform: 'twww' | 'mobile';
}

export const PricingVersion = (props: IPricingVersionProps) => {
    const isEduProfessional = props.isRegisterUser && props.planInfo.teacher_status === 6;
    return (
        <div className="pricing-versions">
            <div className="pricing-version">
                <VersionItem {...props} />
            </div>
            <If condition={props.platform === 'twww'}>
                <div className="asterisk-desc">＊ {isLang('jp') ? '別途料金がかかります' : lang('为付费可选项')}</div>
            </If>
            <div className="edu-version-upgrade">
                <div className="title">{lang('教育专业版')}</div>
                <div className="desc">
                    {lang(
                        '在职教师或教育工作者可申请加入UMU教育计划，免费升级教育专业版。教育专业版权益和专业版相同。',
                    )}
                </div>
                <Button
                    type="ghost"
                    href={addLangPrefixToUrl('/home/edu')}
                    target="_blank"
                    className="price-edition-btn"
                >
                    {isEduProfessional ? lang('正在使用') : lang('免费升级')}
                </Button>
            </div>
        </div>
    );
};
